<template>
    <div id="app">
        <div class="container">
            <div class="row">
                <router-view></router-view>
                <div class="col-md-2">
                    <div class="row">
                        <categories-list />
                    </div>
                    <div class="row">
                        <tag-lists />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import CategoriesList from './CategoriesList.vue';
import TagLists from './TagLists.vue';


export default {
    name: 'app',
    components: {
        CategoriesList,
        TagLists
    }
}
</script>

<style>
.blogItem {
  padding-bottom: 10px;
  border-radius: 5px;
  border: 1px solid #FFAA40;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1); }
  .blogItem:hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22); }
  .blogItem:first-of-type {
    padding-top: 10px;
    margin-top: 10px; }
  .blogItem .card-footer {
    text-align: center; }

.blogPost {
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  border: 1px solid #FFAA40; }

</style>


// WEBPACK FOOTER //
// src/js/components/App.vue?0d53a62c